import { useContext } from "react"
import { QueueContextType, QueueContext } from "../dlQueueContext"

export const useDLQueueContext = (): QueueContextType => {
  const authctx = useContext(QueueContext) as QueueContextType
  if (!authctx) {
    console.error("no provider found, major error")
  }
  return authctx
}
